var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.selectedComponent,{tag:"component",attrs:{"metadata":_vm.metadata},on:{"editStringMetaViewer":_vm.handleEditStringMetaViewer,"editObjMetaViewer":_vm.handleEditObjMetaViewer,"editListMetaViewer":_vm.handleEditListMetaViewer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }